import { render, staticRenderFns } from "./EquipmentOrdersManagement.vue?vue&type=template&id=20fd5cc8&"
import script from "./EquipmentOrdersManagement.vue?vue&type=script&lang=js&"
export * from "./EquipmentOrdersManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/coachingclub/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20fd5cc8')) {
      api.createRecord('20fd5cc8', component.options)
    } else {
      api.reload('20fd5cc8', component.options)
    }
    module.hot.accept("./EquipmentOrdersManagement.vue?vue&type=template&id=20fd5cc8&", function () {
      api.rerender('20fd5cc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Admin/EquipmentOrders/EquipmentOrdersManagement.vue"
export default component.exports